import React, { Component } from 'react';
import FilesStats from './FilesStats';
import FilesFilters from './FilesFilters';
import { FILE_LIST_MODE_TYPES } from '../../../constants/paginationConstants';

class FilesListingView extends Component {
  componentDidMount() {
    this._handleOnRefresh();
  }

  _handleFiltersChanged = (changedFilter) => {
    this.props.updateFilters(changedFilter);
  };

  _handleOnRefresh = () => {
    this.props.updateFilters(this.props.filters);
  };

  render() {
    const { fileStats, files, filters, mode, disablePagination } = this.props;

    return (
      <div>
        {mode !== FILE_LIST_MODE_TYPES.MODE_QUARANTINE_FILES && (
          <FilesStats data={fileStats} onRefresh={this._handleOnRefresh} mode={mode} />
        )}
        <FilesFilters
          meta={files.meta}
          mode={mode}
          disablePagination={disablePagination}
          filters={filters}
          onFiltersChanged={this._handleFiltersChanged}
        />
      </div>
    );
  }
}

FilesListingView.defaultProps = {
  mode: FILE_LIST_MODE_TYPES.MODE_READ,
};

export default FilesListingView;
